var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParameta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 204,
    viewBox: "0 0 153 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 51,
    width: 51,
    height: 51,
    fill: "#071120"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 153,
    width: 51,
    height: 51,
    fill: "#071120"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 51,
    width: 51,
    height: 51,
    fill: "#071120"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 102,
    width: 51,
    height: 51,
    fill: "#071120"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    width: 51,
    height: 51,
    fill: "#071120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 0L153 51H102V0Z",
    fill: "#071120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153 102L102 153L102 102L153 102Z",
    fill: "#071120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameta);
export default __webpack_public_path__ + "static/media/parameta.7d3809eb90d91060e97ae69d156e1389.svg";
export { ForwardRef as ReactComponent };